/**
 */

import React from 'react';
import api from '../utility/api';
import { Map } from 'immutable';
import List from '../screens/list/';
import { connect } from 'react-redux';
import appConstants from '../utility/app-constants'
import { asyncStart, asyncEnd, showFeedback } from '../actions/application';
import { getListUIPreference, setListUIPreference } from '../utility/local-storage';
import { isConnected, setOperatorUpdater, unsetOperatorUpdater } from '../utility/socket-handler';

class OperatorsList extends React.Component {

  constructor() {
    super(...arguments);
    let {defaultSort, pageSize} = this.loadUIPreferences();
    this.state = {
      socketConnection: '',
      operatorMap: Map(),
      sortPref: defaultSort,
      pageSize
    };
  }

  componentDidMount() {
    this.getAvailableOperatorsList()
        .then(() => {
          setOperatorUpdater({
            add: (op) => this.addOperator(op),
            remove: (id) => this.removeOperator(id),
            online: () => this.setState({ socketConnection: 'ONLINE' }),
            offline: () => this.setState({ socketConnection: 'OFFLINE' })
          });

          this.setState({socketConnection: isConnected() ? 'ONLINE' : 'OFFLINE'});
        });
  }

  componentWillUnmount() {
    unsetOperatorUpdater();
  }

  addOperator(operator) {
    const map = this.state.operatorMap.set(operator.id, operator);
    this.setState({operatorMap: map});
  }

  removeOperator(operatorId) {
    const map = this.state.operatorMap.remove(operatorId);
    this.setState({operatorMap: map});
  }

  loadUIPreferences() {
    let listPreference = getListUIPreference(appConstants.LIST.OPERATORS);
    let defaultSort = listPreference && listPreference.sortPref? listPreference.sortPref :
      [
        {
          id: 'userName',
          desc: false
        }
      ];
    let pageSize = listPreference && listPreference.sortPref ? listPreference.pageSize : 20;

    return {defaultSort, pageSize};
  }

  onSortedChange(newSorted){
    let currentPreference = getListUIPreference(appConstants.LIST.OPERATORS);
    currentPreference = currentPreference || {};
    currentPreference.sortPref = newSorted;
    setListUIPreference(appConstants.LIST.OPERATORS, currentPreference);
  }

  onPageSizeChange(pageIndex) {
    let currentPreference = getListUIPreference(appConstants.LIST.OPERATORS);
    currentPreference = currentPreference || {};
    currentPreference.pageSize = pageIndex;
    setListUIPreference(appConstants.LIST.OPERATORS, currentPreference);
  }

  getAvailableOperatorsList() {
    this.props.dispatch(asyncStart());
    return api.getAvailableOperators()
      .then(operatorMap => {
        this.props.dispatch(asyncEnd());
        this.setState({ operatorMap });
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: error.message}));
      });
}

  render() {

    const columns = [{
      Header: 'Id',
      accessor: 'id',
      show: false
    }, {
      id: 'userName',
      Header: 'Name',
      accessor: 'user.name'
    }, {
      id: 'userPhone',
      Header: 'Phone',
      accessor:'user.phone'
    }, {
      id: 'userEmail',
      Header: 'Email',
      accessor: 'user.email'
    }, {
      Header: 'Passed From',
      accessor: 'passed_from'
    }, {
      Header: 'Passing Year',
      accessor: 'passing_year'
    }];

    let {operatorMap, sortPref, pageSize, socketConnection} = this.state;
    let {isLoading} = this.props.application;
    let reactTableProps = {
      data: operatorMap.toArray(),
      columns,
      isLoading,
      noDataText: 'No operators found',
      defaultSorted: sortPref,
      defaultPageSize: pageSize,
      onSortedChange: this.onSortedChange.bind(this),
      onPageSizeChange: this.onPageSizeChange.bind(this)
    };

return (
  <List
    title="Controllers Online"
    addNewBadge={socketConnection}
    reactTableProps={reactTableProps}
 />
  )
 }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(OperatorsList);



// WEBPACK FOOTER //
// ./src/containers/operators.js